/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { Directive } from '@angular/core';
/**
 * The floating placeholder for an `MatFormField`.
 */
export class MatPlaceholder {
}
MatPlaceholder.decorators = [
    { type: Directive, args: [{
                selector: 'mat-placeholder'
            },] },
];
/**
 * @nocollapse
 */
MatPlaceholder.ctorParameters = () => [];
function MatPlaceholder_tsickle_Closure_declarations() {
    /** @type {?} */
    MatPlaceholder.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatPlaceholder.ctorParameters;
}
//# sourceMappingURL=placeholder.js.map